import React from "react";
// Import Material-UI components for layout and styling
import { Box, Grid, Typography, Button } from "@mui/material";
// Import website configuration for images
import { websiteImages } from "../../../config/config";

// Define the RecompPresent component
const RecompPresent = () => {
  return (
    <div>
      {/* Main container with gradient overlay and background image */}
      <Box
        sx={{
          backgroundImage: `
            linear-gradient(to right, rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.1)),
            url(${websiteImages.workoutGirl})
          `,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative",
          minHeight: { xs: "70vh", sm: "80vh", md: "85vh", lg: "90vh" },
          display: "flex",
          alignItems: "center",
          justifyContent: "flex-start",
          color: "#fff",
          px: { xs: 2, sm: 3, md: 4 },
          py: { xs: 4, sm: 6, md: 8 },
        }}
      >
        <Box
          sx={{
            width: "100%",
            maxWidth: "1200px",
            mx: "auto",
          }}
        >
          <Grid container spacing={{ xs: 2, sm: 3, md: 4 }}>
            <Grid
              item
              xs={12}
              md={8}
              lg={7}
              sx={{
                display: "flex",
                flexDirection: "column",
                justifyContent: "center",
              }}
            >
              <Box
                sx={{
                  textAlign: { xs: "left", sm: "left" },
                  maxWidth: { xs: "80%", sm: "65%", md: "60%", lg: "55%" },
                }}
              >
                {/* Subtitle */}
                <Typography
                  variant="subtitle2"
                  sx={{
                    textTransform: "uppercase",
                    letterSpacing: { xs: "4px", sm: "6px", md: "8px" },
                    mb: { xs: 1.5, sm: 2, md: 2.5 },
                    fontWeight: "600",
                    fontSize: {
                      xs: "0.65rem",
                      sm: "0.75rem",
                      md: "0.85rem",
                      lg: "0.9rem",
                    },
                    opacity: 0.9,
                  }}
                >
                  What Is Recomp Plus?
                </Typography>

                {/* Main heading */}
                <Typography
                  variant="h1"
                  component="h1"
                  sx={{
                    textTransform: "uppercase",
                    fontWeight: { xs: 700, md: 800 },
                    lineHeight: { xs: 1.1, sm: 1.15, md: 1.2 },
                    mb: { xs: 2, sm: 2.5, md: 3 },
                    fontSize: {
                      xs: "1.1rem",
                      sm: "1.4rem",
                      md: "1.8rem",
                      lg: "2.1rem",
                      xl: "2.3rem",
                    },
                  }}
                >
                  A Smarter Way to Get Leaner, Stronger, and Fitter — Without
                  Losing Muscle or Starting Over
                </Typography>

                {/* Description */}
                <Typography
                  variant="body1"
                  sx={{
                    lineHeight: { xs: 1.4, sm: 1.5, md: 1.6 },
                    mb: { xs: 2, sm: 2.5, md: 3 },
                    fontSize: {
                      xs: "0.8rem",
                      sm: "0.9rem",
                      md: "1rem",
                      lg: "1.05rem",
                    },
                    opacity: 0.95,
                    fontWeight: { xs: 400, md: 500 },
                  }}
                >
                  Recomp Plus is a proven system — built from 16 years of
                  coaching, refined through real-world results, and tested on
                  the toughest client of all: me. Designed to help everyday
                  people achieve elite-level results — without unsustainable
                  diets, extreme workouts, or guesswork.
                </Typography>

                {/* Features list */}
                <Typography
                  variant="body2"
                  component="div"
                  sx={{
                    lineHeight: { xs: 1.4, sm: 1.5, md: 1.6 },
                    mb: { xs: 3, sm: 3.5, md: 4 },
                    fontSize: {
                      xs: "0.75rem",
                      sm: "0.85rem",
                      md: "0.95rem",
                      lg: "1rem",
                    },
                    "& ul": {
                      paddingLeft: { xs: "1rem", sm: "1.2rem", md: "1.5rem" },
                      margin: 0,
                      listStyleType: "none",
                      position: "relative",
                    },
                    "& li": {
                      color: "#fff",
                      paddingBottom: { xs: "6px", sm: "8px", md: "10px" },
                      fontWeight: { xs: 500, md: 500 },
                      position: "relative",
                      paddingLeft: { xs: "20px", sm: "24px", md: "28px" },
                      "&:before": {
                        content: '""',
                        position: "absolute",
                        left: 0,
                        top: { xs: "8px", sm: "10px", md: "12px" },
                        width: { xs: "6px", sm: "7px", md: "8px" },
                        height: { xs: "6px", sm: "7px", md: "8px" },
                        backgroundColor: "#00ffff",
                        borderRadius: "50%",
                      },
                    },
                  }}
                >
                  <ul>
                    <li>Structured Strength + Hypertrophy Training</li>
                    <li>Customised Nutrition Targets</li>
                    <li>Weekly Check-ins + Photo Tracking</li>
                    <li>Real Coach + Fast Responses</li>
                  </ul>
                </Typography>

                {/* Call-to-action button */}
                <Box
                  sx={{
                    display: "flex",
                    justifyContent: { xs: "flex-start", sm: "flex-start" },
                  }}
                >
                  <Button
                    variant="contained"
                    sx={{
                      backgroundColor: "#00ffff",
                      color: "#000",
                      borderRadius: { xs: "28px", sm: "32px", md: "36px" },
                      px: { xs: 3, sm: 4, md: 5 },
                      py: { xs: 1.2, sm: 1.5, md: 1.8 },
                      textTransform: "uppercase",
                      fontWeight: { xs: 600, md: 700 },
                      transition: "all 0.3s ease",
                      fontSize: {
                        xs: "0.7rem",
                        sm: "0.8rem",
                        md: "0.9rem",
                        lg: "0.95rem",
                      },
                      letterSpacing: { xs: "0.5px", md: "1px" },
                      minWidth: { xs: "160px", sm: "180px", md: "200px" },
                      boxShadow: "0 4px 12px rgba(0, 255, 255, 0.3)",

                      "&:hover": {
                        backgroundColor: "#00e6e6",
                        transform: "translateY(-3px)",
                        boxShadow: "0 8px 24px rgba(0, 255, 255, 0.4)",
                      },

                      "&:active": {
                        transform: "translateY(-1px)",
                      },
                    }}
                    onClick={() => {
                      const section = document.getElementById(
                        "subscription-section"
                      );
                      if (section) {
                        section.scrollIntoView({ behavior: "smooth" });
                      }
                    }}
                  >
                    See How It Works
                  </Button>
                </Box>
              </Box>
            </Grid>

            {/* Empty grid item for spacing */}
            <Grid item xs={0} md={4} lg={5} />
          </Grid>
        </Box>
      </Box>
    </div>
  );
};

// Export the RecompPresent component
export default RecompPresent;
